import jQuery from 'jquery';
import './scss/main.scss'

import Router from './js/util/Router';
import common from './js/routes/common';
import home from './js/routes/home';

import {preloader} from './js/menu/preloader';
//import LocomotiveScroll from 'locomotive-scroll';
import Menu from './js/menu/menu';

// menu (<nav> element)
const menuEl = document.querySelector('.menu');
const vrMenuEl = document.querySelector('.vr-menu');

// preload the images set as data attrs in the menu items
preloader('.menu__item').then(() => {
    // initialize the smooth scroll
    //const scroll = new LocomotiveScroll({el: menuEl, smooth: true});
    // initialize menu
    new Menu(menuEl);
    new Menu(vrMenuEl);
});

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  home
  /** About Us page, note the change from about-us to aboutUs. */
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());


